// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__8ZDOa","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__s5GdU"};